import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';

@Injectable({
	providedIn: 'root'
})
export class ParametrageService {
	// Injections
	private readonly http = inject(HttpClient);

	private url = '/ws/parametrages';

	/**
	 * Retourne le nombre de places par défaut pour un trajet en navette.
	 *
	 * @returns {Number} le nombre de places par défaut d'une navette.
	 */
	getNombrePlacesDefautNavette(): Observable<number> {
		const params = new HttpParams().set('use-case', 'nombre-places-defaut-navette');
		return this.http.get<number>(this.url, { params: params });
	}

	/**
	 * Retourne le délai limite de réservation d'un trajet après son départ, en minutes.
	 *
	 * @returns {Number} le délai limite de réservation d'un trajet après son départ, en minutes.
	 */
	getDelaiLimiteReservationTrajet(): Observable<number> {
		const params = new HttpParams().set('use-case', 'delai-limite-reservation-trajet');
		return this.http.get<number>(this.url, { params: params });
	}

	/**
	 * Retourne le délai limite d'annulation d'une réservation de trajet avant son départ, en minutes.
	 *
	 * @return {Observable<number>} le délai limite d'annulation d'une réservation de trajet avant son départ, en minutes.
	 */
	getDelaiLimiteAnnulationReservationTrajet(): Observable<number> {
		const params = new HttpParams().set('use-case', 'delai-limite-annulation-reservation-trajet');
		return this.http.get<number>(this.url, { params: params });
	}

	/**
	 * Retourne le lien Google Maps de base pour la recherche d'adresse.
	 *
	 * Exposé comme signal (via toSignal) plutôt qu'Observable : le service étant un singleton,
	 * toSignal souscrit une seule fois à l'appel HTTP — tous les composants lisent ensuite
	 * la même valeur en mémoire, sans déclencher de nouvel appel ni de subscribe local.
	 */
	readonly lienGoogleMaps = toSignal(
		this.http.get(this.url, {
			params: new HttpParams().set('use-case', 'lien-google-maps'),
			responseType: 'text'
		}),
		{ initialValue: null }
	);
}